/**
 * T16-D2 — which navigation-drawer route is "current" for a pathname: an
 * exact match or a child route of an item's path (`/admin/users/x` →
 * `/admin/users`); the LONGEST matching item path wins. Null when no item
 * matches (e.g. Submission Details, which has no drawer item).
 */
export function currentNavPath(pathname: string, itemPaths: readonly string[]): string | null {
  let best: string | null = null;
  for (const p of itemPaths) {
    if ((pathname === p || pathname.startsWith(`${p}/`)) && (best === null || p.length > best.length)) {
      best = p;
    }
  }
  return best;
}
